import { getAuthData } from "../features/auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import "./HomePage.css";
import { EventEntry } from "../features/seasonal-games/EventEntry.jsx";
import { HalloweenPanelDecor } from "../components/HalloweenAccents.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { fetchCardUniverses } from "../api/cardOpening.jsx";
import { fetchCardPreview } from "../api/cardOpening.jsx";
import { Ns } from "../assets.jsx";
import { IconRoulette } from "../components/icons.jsx";
import { n2 } from "../assets.jsx";
import { IconTrophy } from "../components/icons.jsx";
import { preloadNextCards } from "../features/opening/art.jsx";
import { preloadCardArt } from "../features/opening/art.jsx";
import { IconChevronRight } from "../components/icons.jsx";
import { IconCheck } from "../components/icons.jsx";
import { ResourceSummaryStrip } from "../components/ResourceSummaryStrip.jsx";
import { universeArtwork } from "../features/startup/assets.jsx";
import { IconChevronDown } from "../components/icons.jsx";
import { IconCards } from "../components/icons.jsx";
import { IconX } from "../components/icons.jsx";
import { OpeningReveal } from "../features/opening/OpeningReveal.jsx";
import { getFreeCardAvailability, getFreeSpinStock } from "../features/opening/availability.js";
export const s2 = "_page_fwc81_1";
export const i2 = "_resources_fwc81_2";
export const c2 = "_universePicker_fwc81_3";
export const u2 = "_universeArt_fwc81_5";
export const o2 = "_universeName_fwc81_7";
export const r2 = "_cardStage_fwc81_9";
export const d2 = "_cardBack_fwc81_12";
export const f2 = "_cardArt_fwc81_13";
export const h2 = "_left_fwc81_14";
export const m2 = "_floatLeft_fwc81_1";
export const p2 = "_right_fwc81_15";
export const v2 = "_floatRight_fwc81_1";
export const b2 = "_center_fwc81_16";
export const g2 = "_floatCenter_fwc81_1";
export const y2 = "_cardBackInner_fwc81_17";
export const _2 = "_spinning_fwc81_22";
export const j2 = "_pulse_fwc81_1";
export const x2 = "_amounts_fwc81_23";
export const S2 = "_activeAmount_fwc81_25";
export const w2 = "_openButton_fwc81_27";
export const N2 = "_sectionsGrid_fwc81_30";
export const T2 = "_sectionTile_fwc81_31";
export const C2 = "_sectionImage_fwc81_36";
export const M2 = "_modal_fwc81_41";
export const A2 = "_backdrop_fwc81_42";
export const E2 = "_sheet_fwc81_43";
export const D2 = "_universeList_fwc81_48";
export const z2 = "_universeOptionArt_fwc81_51";
export const O2 = "_universeOptionName_fwc81_53";
export const k2 = "_activeUniverse_fwc81_55";
export const tt = {
  page: s2,
  resources: i2,
  universePicker: c2,
  universeArt: u2,
  universeName: o2,
  cardStage: r2,
  cardBack: d2,
  cardArt: f2,
  left: h2,
  floatLeft: m2,
  right: p2,
  floatRight: v2,
  center: b2,
  floatCenter: g2,
  cardBackInner: y2,
  spinning: _2,
  pulse: j2,
  amounts: x2,
  activeAmount: S2,
  openButton: w2,
  sectionsGrid: N2,
  sectionTile: T2,
  sectionImage: C2,
  modal: M2,
  backdrop: A2,
  sheet: E2,
  universeList: D2,
  universeOptionArt: z2,
  universeOptionName: O2,
  activeUniverse: k2
};
export const yx = [1, 10, 50];
export function HomeCard({
  position: u,
  card: o
}) {
  const [m, r] = React.useState(!1);
  return React.useEffect(() => r(!1), [o?.thumbnailPath]), jsxRuntime.jsxs("span", {
    className: `${tt.cardBack} ${tt[u]}`,
    "aria-hidden": "true",
    children: [jsxRuntime.jsx(HalloweenPanelDecor, { variant: "card" }), o && !m ? jsxRuntime.jsx("img", {
      className: tt.cardArt,
      src: `/${o.thumbnailPath.replace(/^\/+/, "")}`,
      alt: "",
      onError: () => r(!0)
    }) : jsxRuntime.jsxs("span", {
      className: tt.cardBackInner,
      children: [jsxRuntime.jsx("i", {
        children: "✦"
      }), jsxRuntime.jsx("b", {
        children: "✧"
      })]
    })]
  });
}
export function HomePage({
  metacoins: u,
  resources: o,
  meta: m,
  onOpenCards: r,
  onChangeUniverse: g,
  onOpenCases: j,
  onOpenRating: B,
  onOpenMetaPass: U,
  onOpenMiniGames: N,
  onOpenHalloween,
  onNotice: y,
  startupData: X
}) {
  const [M, R] = React.useState(1),
    [H, Y] = React.useState(!1),
    [P, W] = React.useState(null),
    [ee, ie] = React.useState(!1),
    [w, I] = React.useState(X?.universes ?? []),
    [ne, oe] = React.useState(X?.universe ?? ""),
    [T, D] = React.useState(X?.cards ?? []),
    le = React.useRef(null),
    te = React.useRef(!1),
    Z = ["VIP", "MVP", "X", "OP", "GOD", "LEGEND", "admin"].includes(m.privilege),
    V = Z ? M : 1,
    Te = m.universe || "Multiverse";
  const [now, setNow] = React.useState(Date.now);
  const stock = getFreeSpinStock(m, now);
  const totalSpins = o.spins + (stock?.available ?? 0);
  const ae = V > 1 && V > totalSpins;
  const freeCard = getFreeCardAvailability(m.freeCardAvailableAt, now);
  const waitingForFreeCard = totalSpins <= 0 && V === 1 && freeCard.waiting;
  const freeCardUnavailable = totalSpins <= 0 && (!freeCard.known || freeCard.waiting);
  React.useEffect(() => {
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [m.freeCardAvailableAt, m.freeSpinNextAt]);
  React.useEffect(() => {
    if (totalSpins <= 0) R(1);
  }, [totalSpins]);
  React.useEffect(() => {
    !X || ne || (I(X.universes), oe(X.universe), D(X.cards));
  }, [X, ne]), React.useEffect(() => {
    if (X) return;
    let C = !0;
    const f = getAuthData();
    if (f) return fetchCardUniverses(f).then(h => {
      C && (I(h.universes), oe(h.universe));
    }).catch(() => {}), () => {
      C = !1;
    };
  }, [X]), React.useEffect(() => {
    const C = getAuthData();
    if (!C || !ne || X?.universe === ne) return;
    const f = new AbortController();
    return D([]), fetchCardPreview(C, ne, f.signal).then(h => D(h.cards.filter(p => p.rarity.toLowerCase() !== "absolute"))).catch(() => {}), () => f.abort();
  }, [ne, X]);
  const je = [{
      id: "cases",
      title: "Кейсы",
      image: Ns,
      action: j
    }, {
      id: "minigames",
      title: "Мини-игры",
      icon: jsxRuntime.jsx(IconRoulette, {
        "aria-hidden": "true"
      }),
      action: N
    }, {
      id: "metapass",
      title: "MetaPass",
      image: n2,
      action: U
    }, {
      id: "rating",
      title: "Рейтинг",
      icon: jsxRuntime.jsx(IconTrophy, {}),
      action: B
    }],
    k = async () => {
      if (w.length) {
        ie(!0);
        return;
      }
      const C = getAuthData();
      if (!C) {
        y("Выбор вселенной доступен внутри Telegram");
        return;
      }
      try {
        const f = await fetchCardUniverses(C);
        I(f.universes), oe(f.universe), ie(!0);
      } catch {
        y("Не удалось загрузить вселенные");
      }
    },
    O = async C => {
      try {
        await g(C), oe(C), ie(!1);
      } catch (f) {
        y(f instanceof Error ? f.message : "Не удалось сменить вселенную");
      }
    },
    L = async () => {
      if (!te.current) {
        if (freeCardUnavailable) return;
        if (ae) {
          y(`Недостаточно круток: доступно ${totalSpins}`);
          return;
        }
        te.current = !0, Y(!0), le.current ||= crypto.randomUUID();
        try {
          const C = await r(V, le.current);
          C.status === "processing" ? y("Открытие ещё выполняется. Нажмите повторно, чтобы проверить результат") : (le.current = null, C.cards.length ? (preloadNextCards(C.cards), await preloadCardArt(C.cards[0]), W(C)) : C.error && y(C.error));
        } catch (C) {
          y(C instanceof Error ? C.message : "Не удалось проверить открытие");
        } finally {
          te.current = !1, Y(!1);
        }
      }
    },
    se = jsxRuntime.jsx("div", {
      className: tt.sectionsGrid,
      children: je.map(C => jsxRuntime.jsxs("button", {
        type: "button",
        className: tt.sectionTile,
        onClick: C.action,
        children: [jsxRuntime.jsx(HalloweenPanelDecor, { variant: C.id }), jsxRuntime.jsx("span", {
          className: tt.sectionImage,
          children: C.image ? jsxRuntime.jsx("img", {
            src: C.image,
            alt: ""
          }) : C.icon
        }), jsxRuntime.jsx("b", {
          children: C.title
        }), jsxRuntime.jsx(IconChevronRight, {
          "aria-hidden": "true"
        })]
      }, C.id))
    });
  return jsxRuntime.jsxs("section", {
    className: `${tt.page} home-halloween`,
    children: [jsxRuntime.jsx(ResourceSummaryStrip, {
      metacoins: u,
      resources: o,
      className: tt.resources
    }), jsxRuntime.jsxs("button", {
      type: "button",
      className: tt.universePicker,
      onClick: () => {
        k();
      },
      "aria-label": `Вселенная: ${m.universe || "Мультиверс"}. Выбрать другую`,
      children: [jsxRuntime.jsx(HalloweenPanelDecor, { variant: "universe" }), jsxRuntime.jsx("span", {
        className: tt.universeArt,
        "aria-hidden": "true",
        children: jsxRuntime.jsx("img", {
          src: universeArtwork(ne),
          alt: ""
        })
      }), jsxRuntime.jsx("span", {
        className: tt.universeName,
        children: Te
      }), jsxRuntime.jsx(IconChevronDown, {
        "aria-hidden": "true"
      })]
    }), jsxRuntime.jsxs("div", {
      className: `${tt.cardStage} ${H ? tt.spinning : ""}`,
      role: "img",
      "aria-label": T.length ? `Примеры карт этой вселенной: ${T.map(C => C.name).join(", ")}` : "Карты этой вселенной",
      children: [jsxRuntime.jsx(HalloweenPanelDecor, { variant: "stage" }), jsxRuntime.jsx(HomeCard, {
        position: "left",
        card: T[0]
      }), jsxRuntime.jsx(HomeCard, {
        position: "right",
        card: T[1]
      }), jsxRuntime.jsx(HomeCard, {
        position: "center",
        card: T[2]
      })]
    }), jsxRuntime.jsxs("div", {
      className: "home-opening-controls",
      children: [Z && jsxRuntime.jsx("div", {
      className: tt.amounts,
      role: "group",
      "aria-label": "Количество карт",
      children: yx.map(C => jsxRuntime.jsxs("button", {
        type: "button",
        disabled: H || C > 1 && C > totalSpins,
        title: C > totalSpins && C > 1 ? `Нужно ${C} круток` : void 0,
        className: M === C ? tt.activeAmount : "",
        onClick: () => {
          R(C), le.current = null;
        },
        "aria-pressed": M === C,
        children: ["×", C]
      }, C))
    }), jsxRuntime.jsxs("button", {
      type: "button",
      className: tt.openButton,
      onClick: () => {
        L();
      },
      disabled: H || ae || freeCardUnavailable,
      children: [jsxRuntime.jsx(IconCards, {
        "aria-hidden": "true"
      }), jsxRuntime.jsxs("span", {
        className: "home-opening-label",
        children: [jsxRuntime.jsx("span", {
          children: H ? "Открываем карты…" : ae ? `Не хватает круток: ${V - totalSpins}` : V === 1 && totalSpins <= 0 ? freeCard.label : `Открыть ${V} ${V === 1 ? "карту" : "карт"}`
        }), stock && jsxRuntime.jsx("small", {
          children: `Бесплатные крутки: ${stock.available}/${stock.capacity}`
        }), !H && waitingForFreeCard && jsxRuntime.jsx("small", {
          children: "Или 1 крутка для открытия сейчас"
        })]
      })]
    })]
    }), jsxRuntime.jsx(EventEntry, { onOpen: onOpenHalloween }), se, ee && jsxRuntime.jsxs("div", {
      className: tt.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Выбор вселенной",
      children: [jsxRuntime.jsx("button", {
        type: "button",
        className: tt.backdrop,
        "aria-label": "Закрыть выбор вселенной",
        onClick: () => ie(!1)
      }), jsxRuntime.jsxs("div", {
        className: tt.sheet,
        children: [jsxRuntime.jsxs("header", {
          children: [jsxRuntime.jsx("h2", {
            children: "Выбрать вселенную"
          }), jsxRuntime.jsx("button", {
            className: "mc-icon-button",
            type: "button",
            onClick: () => ie(!1),
            "aria-label": "Закрыть",
            children: jsxRuntime.jsx(IconX, {})
          })]
        }), jsxRuntime.jsx("div", {
          className: tt.universeList,
          children: [...w.filter(C => C.key === ne), ...w.filter(C => C.key !== ne)].map(C => jsxRuntime.jsxs("button", {
            type: "button",
            className: C.key === ne ? tt.activeUniverse : "",
            "aria-pressed": C.key === ne,
            onClick: () => {
              O(C.key);
            },
            children: [jsxRuntime.jsx("span", {
              className: tt.universeOptionArt,
              "aria-hidden": "true",
              children: jsxRuntime.jsx("img", {
                src: universeArtwork(C.key),
                alt: "",
                loading: "lazy"
              })
            }), jsxRuntime.jsxs("span", {
              className: tt.universeOptionName,
              children: [jsxRuntime.jsx("span", {
                className: "home-universe-option-title",
                children: C.name
              }), C.key === ne && jsxRuntime.jsx("span", {
                className: "home-universe-selected-label",
                children: "Выбрана"
              })]
            }), jsxRuntime.jsx(C.key === ne ? IconCheck : IconChevronRight, {
              "aria-hidden": "true"
            })]
          }, C.key))
        })]
      })]
    }), P && jsxRuntime.jsx(OpeningReveal, {
      result: P,
      onClose: () => W(null)
    })]
  });
}
